const SCROLL_TO_SELECTOR = '[data-scroll-to]'

const getHeaderOffset = () => {
  const stickyHeader = document.querySelector('.page-header__wrap')
  if (!stickyHeader) {
    return 24
  }

  return Math.ceil(stickyHeader.getBoundingClientRect().height) + 16
}

const resolveTarget = (value) => {
  if (!value) {
    return null
  }

  try {
    return document.querySelector(value)
  } catch {
    return document.getElementById(value)
  }
}

const scrollToTarget = (trigger) => {
  const targetSelector = trigger.getAttribute('data-scroll-to')
  const target = resolveTarget(targetSelector)

  if (!target) {
    return
  }

  const customOffset = Number.parseInt(
    trigger.getAttribute('data-scroll-offset') || '',
    10,
  )
  const offset = Number.isFinite(customOffset)
    ? customOffset
    : getHeaderOffset()

  const top = window.scrollY + target.getBoundingClientRect().top - offset
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches

  window.scrollTo({
    top,
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  })
}

const onClick = (event) => {
  const trigger = event.target.closest(SCROLL_TO_SELECTOR)
  if (!trigger) {
    return
  }

  event.preventDefault()
  scrollToTarget(trigger)
}

let isBound = false

export const initScrollToComponents = () => {
  if (isBound) {
    return
  }

  document.addEventListener('click', onClick)
  isBound = true
}
